// Module
var code = `<div class="filters">
  <span class="labelled-field">
    <label>Passbook number</label>
    <input disabled
           type="text"
           ng-model="\$ctrl.passbookObj.number"/>
  </span>
  <button type="button"
          ng-if="\$ctrl.productGroup === 'TERM_DEPOSIT'"
          command-access="UpdateTermDepositPassbookNumber"
          ng-click="\$ctrl.editNumber()"
          class="btn">
    Edit Number
  </button>
  <button type="button"
          ng-if="\$ctrl.productGroup === 'DEPOSIT_ACCOUNT' && ['ACTIVE', 'INACTIVE', 'MATURE'].includes(\$ctrl.product.status)"
          command-access="UpdateDepositAccountPassbookNumber"
          ng-click="\$ctrl.editNumber()"
          class="btn">
    Edit Number
  </button>
</div>
<div class="right-header-panel">
  <div class="switch">
    <input id="showPrintedCheckbox" type="checkbox" ng-model="\$ctrl.showPrinted" ng-change="\$ctrl.reloadTableConfig()"/>
    <label for="showPrintedCheckbox">Show printed operations</label>
  </div>
</div>
<table class="table" ng-table="\$ctrl.passbookHistoryConfig">
  <thead>
  <tr>
    <th>No</th>
    <th>Date and time</th>
    <th>Type</th>
    <th>Code</th>
    <th>Status</th>
    <th>Amount</th>
    <th>Total balance after</th>
    <th>Transaction Status</th>
    <th ng-if="\$ctrl.hasSomeQualifiedPrints">
      <div class="print-config-row">
      <div class="btn-group">
        <button class="btn btn-primary dropdown-toggle"
                command-access="ReprintDepositPassbook"
                data-toggle="dropdown"
                type="button"
                ng-disabled="!\$ctrl.canPrint(\$data) || !\$ctrl.hasSomeQualifiedPrints || !\$ctrl.displayLine">Print&nbsp;<span class="caret"></span>
        </button>
        <ul class="dropdown-menu">
          <li ng-repeat="print in \$ctrl.renderablePrints"
              ng-if="\$ctrl.prints !== null && \$ctrl.isPrintQualified(print)">
            <a ng-click="\$ctrl.printPassbook(\$data, print.code)">{{ \$ctrl.toPrettyCode(print.code) }}</a>
          </li>
        </ul>
      </div>
        <span class="label">from</span>
         <input type="number"
                    placeholder="line no"
                    ng-model="\$ctrl.displayLine"
                    ng-disabled="!\$ctrl.canPrint(\$data)"
                    min="1"
                    max="{{\$ctrl.maxDisplayLine}}"/>
      </div>
    </th>
  </tr>
  </thead>
  <tbody>
  <tr ng-repeat="item in \$data"
      ng-click="\$ctrl.transactionClicked(item, \$event)"
      ng-class="{'selected': \$ctrl.selectedTransactionId === item.id}">
    <td>
      {{\$index+1 + (\$ctrl.passbookHistoryConfig.page() - 1) * \$ctrl.passbookHistoryConfig.count()}}
    </td>
    <td>{{item.processedOn | prettyDateTime }}</td>
    <td class="type-{{item.entryType}}">{{\$ctrl.translate(item)}}</td>
    <td>{{\$ctrl.getOperationCode(item) | translate:'OPERATION_SHORT_CODE':'-'}}</td>
    <td class="printed-{{item.printedInPassbook}}">{{item.printedInPassbook ? 'Printed' : 'Not printed'}}</td>
    <td>{{item.amount | nxCurrency}}</td>
    <td>{{item.balanceAfter + item.holdsAfter | nxCurrency}}</td>
    <td class="status-{{item.transactionStatusLabel | uppercase}}">
      {{item.transactionStatusLabel}}
    </td>
    <td></td>
    <td ng-if="\$ctrl.hasSomeQualifiedPrints" class="text-center">
      <input type="checkbox"
             ng-model="item.markedForPrintingInPassbook"
             ng-change="\$ctrl.updateCheckboxForPrinting(item)"/>
    </td>
  </tr>
  </tbody>
</table>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/common/passbook/passbook.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;